











































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import BaseRepository from "@/core/HttpResources/BaseRepository";
import Documento from "@/models/documento.model";
import BTableColumn from "@/models/base/BTableColumn.model";
import GenericBTable from "@/core/Generics/GenericBTable";
import { BTableColumnType } from "@/enums/BTableColumnType";
import fileService, { getDocumentDownloadErrorMessage } from "@/services/file.service";

@Component
export default class DocumentoTable extends GenericBTable<Documento> {
  @Prop() readonly selected!: Documento;
  @Prop() readonly showTitle!: boolean;
  @Prop() readonly multiple!: boolean;
  @Prop() readonly selectable!: boolean;
  @Prop() readonly title!: string;
  @Prop() readonly aggregable!: string;

  @Prop() readonly whereParams!: string;
  @Prop() readonly refName!: string;
  @Prop() readonly refKey!: string;
  @Prop() readonly refValue!: string;
  @Prop() readonly tipoDocumentoId!: number;

  archivo: File | null = null;
  documento: Documento | undefined = this.selected || undefined;
  uploading = false;
  errorUpload = false;
  successUpload = false;

  get isMobile() {
    return this.$store.state.isMobile;
  }
  created() {
    this.setupTable();
    this.formatColumns();
  }
  setupTable() {
    this.tableConfig.controller = "documento";
    this.tableConfig.whereParams = this.queries;
    this.tableConfig.activeActions = false;
    this.tableConfig.enableDefaultColumns = false;
    this.tableConfig.selectable = this.selectable;
    this.tableConfig.checkable = this.multiple;
    this.tableConfig.style.narrowed = true;
    this.tableConfig.pagination.perPage = 5;
    this.tableConfig.emptyText = "No hay documentos asociados.";
    if (this.tableConfig.checkable)
      this.tableConfig.checking.check = this.onCheck;
    if (this.tableConfig.selectable)
      this.tableConfig.selection.change = this.onSelect;
  }
  formatColumns() {
    let preview = new BTableColumn("preview", String(" "), false);
    preview.customTemplate = true;
    preview.width = "60";
    let nombre = new BTableColumn("nombreOriginal", "Documento");
    let fecha = new BTableColumn("createdDate", "Fecha");
    fecha.type = BTableColumnType.DateTime;
    this.tableConfig.insertColumns(preview, nombre, fecha);
  }
  public onCheck(list: Documento[], row: Documento) {
    this.$emit("current-check", row);
    this.$emit("check", list);
  }
  public onSelect(row: Documento, oldRow: Documento) {
    this.$emit("select", row);
  }
  async verDocumento(id: number) {
    try {
      await fileService.download(id);
    } catch (error) {
      this.operationFailed(getDocumentDownloadErrorMessage(error));
    }
  }

  public add() {}
  quitarArchivo() {
    this.archivo = null;
    this.documento = undefined;
    this.tableConfig.selection.selected = undefined;
    let selected = this.map<Documento>(this.selected);
    this.$emit("remove", selected);
  }
  selectFile(file: File) {
    this.errorUpload = false;
    this.successUpload = false;
    this.archivo = file;
    this.subirArchivo();
    this.$emit("selectFile", this.archivo);
  }
  async subirArchivo() {
    try {
      this.uploading = true;
      let doc = await fileService.upload(this.archivo as File);
      this.documento = new Documento(
        doc.fileName,
        doc.contentType,
        doc.nombreOriginal
      );
      this.documento.refEntityName = this.refName;
      this.documento.refEntityKey = this.refKey;
      this.documento.refEntityValue = this.refValue;
      this.documento.tipoDocumentoId = this.tipoDocumentoId;
      this.successUpload = true;
      this.tableConfig.selection.selected = undefined;
      this.$emit("select", this.documento);
    } catch (error) {
      this.errorUpload = true;
    } finally {
      this.uploading = false;
    }
  }
  get queries() {
    let where = String();
    let queries = [];
    queries.push(`tipoDocumentoId=${this.tipoDocumentoId}`);
    if (this.refName) {
      queries.push(`refEntityName="${this.refName}"`);
      queries.push(`refEntityKey="${this.refKey}"`);
      queries.push(`refEntityValue="${this.refValue}"`);
    }

    where = queries.join("&");
    if (this.whereParams) where += this.whereParams;
    return where;
  }

  @Watch("tipoDocumenoId")
  onTipoDocumentoChange(value: number | undefined) {
    this.tableConfig.whereParams = this.queries;
    if (this.tableConfig.reload) this.tableConfig.reload();
  }

  @Watch("refValue")
  onRefValueChanve(value: string | undefined) {
    this.tableConfig.whereParams = this.queries;
    if (this.tableConfig.reload) this.tableConfig.reload();
  }
}
